<template>
  <div class="box__view">
    <el-table :data="value" row-class-name="my-row" style="width: 100%">
      <el-table-column label="箱子ID" prop="deliveryTaskCode">
        <template slot-scope="props">

          <span> 箱子 ({{ props.row.length }}x{{ props.row.width }}x{{ props.row.height }}) &nbsp;ID - {{
            props.$index + 1
            }} </span>
        </template>
      </el-table-column>
      <el-table-column label="重量/KG" prop="containerWeight">
        <template slot-scope="props">
          <span> {{ props.row.weight / 1000 }} KG </span>
        </template>
      </el-table-column>
      <el-table-column label="件数" prop="logisticsCode">
        <template slot-scope="props">
          <span> {{ props.row.nums }} 件</span>
        </template>
      </el-table-column>
      <el-table-column label="重量上限" prop="containerWeight">
        <template slot-scope="props">
          <span> {{ (!props.row.weightLimit || props.row.weightLimit == '-1') ? '无限制' : props.row.weightLimit + 'KG' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="美金上限" prop="containerWeight">
        <template slot-scope="props">
          <span> {{ (!props.row.priceLimit || props.row.priceLimit == '-1') ? '无限制' : props.row.priceLimit + '美元'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="logisticsCode" :width="260">
        <template slot-scope="props">
          <el-button type="primary" @click="addProduct(props.row)">添加商品</el-button>
          <el-button type="primary" v-if="!!props.row.nums" @click="maxCopy(props.row)">批量复制</el-button>
          <el-popconfirm
            title="确认删除该箱子吗？"
            @confirm="delBox(props.row)"
          >
            <el-button slot="reference" type="danger">删除</el-button>
          </el-popconfirm>
          <BoxView @close="closeBoxView" :boxTemplateList="boxTemplateList"
            :ref="`boxViewAdd${props.row.deliveryBoxId}`" @change="boxChangeCall" :boxTemplates='value'
            :insidePackCode="insidePackCode" :deliveryTaskCode="deliveryTaskCode" :boxInfo="props.row" />
        </template>
      </el-table-column>
    </el-table>
    <MoreCopyDialog packingType="1" ref="moreCopy" />
  </div>
</template>

<script>
import BoxView from "@/views/outOfStock/FBABagPackage/components/BoxView";
import MoreCopyDialog from "./moreCopyDialog.vue"
import { delContainerBox } from "@/apis/outStock";
import { getBox } from "@/apis/outStock";
export default {
  name: "BoxList",
  components: {
    BoxView,
    MoreCopyDialog
  },
  data() {
    return {
      innerDrawer: false,
      boxTemplateList: [],
    };
  },
  inject: ["productSkuAll"],
  props: {
    value: {
      type: Array,
      default: (_) => [],
    },
    insidePackCode: {
      type: String | Number,
      required: true,
    },
    deliveryTaskCode: {
      type: String | Number,
      required: true,
    },
    openBoxInfo: {
      type: String
    }
  },
  mounted() {
    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplateList = data
      }
    })
  },
  methods: {
    closeBoxView() {
      this.$emit('refresh')
    },
    maxCopy(data) {
      console.log(data);
      this.$refs.moreCopy.showDialog(data);
    },
    delBox: function (b) {
      console.log(b);
      const that = this;
      const params = {
        deliveryBoxCode: b.deliveryBoxCode,
      };
      delContainerBox(params).then((res) => {
        console.log(res);
        const { code = -1 } = res;
        if (code === 0) {
          that.$message.success("删除成功");
          that.$bus.$emit("triggerRefreshFBA");
        } else {
          that.$message.error("删除失败");
        }
      });
    },
    addProduct: function (b) {
      console.log('b', b, this.value, this.$refs);
      const that = this;
      that.$emit('openBoxInfo', b.deliveryBoxId)
      that.$refs[`boxViewAdd${b.deliveryBoxId}`].open();
    },
    // 箱子信息修改成功回调
    boxChangeCall: function (box) {
      console.log("添加商品", box);
      const that = this;
      const deliveryBoxList = that.value.map((item) => {
        if (item.deliveryBoxCode === box.deliveryBoxCode) {
          item = box;
        }
        return item;
      });
      console.log(deliveryBoxList);
      deliveryBoxList.forEach((temp) => {
        let num = 0;
        temp.deliveryBoxDetailList.forEach((item) => {
          num += item.nums;
        });
        temp.nums = num;
      });
      console.log('deliveryBoxList', deliveryBoxList)
      that.$emit("input", deliveryBoxList);
      that.$emit('refresh')
    },
  },
};
</script>

<style scoped>
.box__view {
  margin: 6px;
  background: #efefef;
  padding: 6px;
  border-radius: 10px;
}

.el-table ::v-deep .my-row {
  background: #efefef;
}

.el-table__header-wrapper ::v-deep tr {
  background-color: transparent;
}

.el-table__header-wrapper ::v-deep td {
  background-color: transparent;
}

.el-table__header-wrapper ::v-deep th {
  background-color: transparent;
}
</style>
